var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_5599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36121 1.31254L8.48637 1.30476L16.2645 1.30476C16.5036 1.3054 16.7345 1.39164 16.9154 1.54786C17.0963 1.70408 17.2153 1.91994 17.2508 2.15633C17.2863 2.39272 17.2359 2.634 17.1088 2.83646C16.9817 3.03891 16.7863 3.18913 16.558 3.25992L16.5573 7.74509L18.2353 11.4369C18.2796 11.5343 18.308 11.6381 18.3194 11.7445L18.3265 11.8506L18.3265 13.9719C18.3263 14.2154 18.2372 14.4504 18.0761 14.6329C17.9149 14.8155 17.6927 14.9329 17.4511 14.9632L17.3252 14.9717L13.376 14.9724L13.3753 20.3358C13.3749 20.5899 13.2778 20.8343 13.1037 21.0193C12.9296 21.2044 12.6916 21.3162 12.438 21.3322C12.1844 21.3481 11.9343 21.2669 11.7384 21.1051C11.5426 20.9433 11.4156 20.713 11.3834 20.461L11.3756 20.3358L11.3749 14.9724L7.42571 14.9717C7.1822 14.9717 6.94707 14.8829 6.76442 14.7218C6.58177 14.5608 6.46415 14.3386 6.43364 14.097L6.42586 13.9719L6.42586 11.8506C6.42567 11.7437 6.44262 11.6374 6.47607 11.5359L6.51566 11.4369L8.19221 7.74509L8.19292 3.26133C7.97351 3.19483 7.7836 3.05496 7.65502 2.86515C7.52644 2.67533 7.46699 2.44709 7.48662 2.21866C7.50626 1.99024 7.60379 1.77549 7.76288 1.61041C7.92197 1.44532 8.13367 1.34061 8.36121 1.31254Z",
    fill: "#5B75FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_5599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ef10a3514f8e04c9a2eb4c6e5988dcd4.svg";
export { ForwardRef as ReactComponent };